import axios from 'axios';
import { bookingsWriteApi } from '@api/api';

export type NotificationChannel = 'email' | 'sms' | 'whatsapp' | 'both';

export interface NotifyCustomerInput {
  bookingId: string;
  subject?: string;
  message: string;
  channel?: NotificationChannel;
}

export interface WaitingListMatchSummary {
  id: string;
  customerName: string;
  customerPhone?: string | null;
  dateFrom: string;
  dateTo: string;
  timeFrom?: string | null;
  timeTo?: string | null;
  priority: number;
}

export interface CancelBookingResult {
  bookingId: string;
  bookingCode: string;
  matchingWaitingList: WaitingListMatchSummary[];
}

const BASE_PATH = '/api/services/reservare-be';

export async function cancelBooking(bookingId: string, reason?: string): Promise<CancelBookingResult> {
  const res = await bookingsWriteApi.cancelBooking({
    bookingId,
    cancelBookingRequest: { cancellationReason: reason },
  });
  const data = res.data as any;
  return {
    bookingId: data.bookingId,
    bookingCode: data.bookingCode,
    matchingWaitingList: (data.matchingWaitingList ?? []) as WaitingListMatchSummary[],
  };
}

export async function notifyCustomer(input: NotifyCustomerInput): Promise<void> {
  await axios.post(
    `${BASE_PATH}/bookings/${input.bookingId}/notify`,
    {
      subject: input.subject,
      message: input.message,
      channel: input.channel ?? 'email',
    },
    { withCredentials: true, headers: { 'X-Auth': 'Auth0' } }
  );
}

export interface BuildCancellationMessageInput {
  customerFirstName: string;
  customerLastName: string;
  bookingStart: string;
  blockTitle: string;
  reason?: string;
}

export function buildCancellationMessage(input: BuildCancellationMessageInput): string {
  const dt = new Date(input.bookingStart).toLocaleString('cs-CZ');
  return (
    `Vážený/á ${input.customerFirstName} ${input.customerLastName},\n\n` +
    `oznamujeme Vám, že Vaše rezervace na ${dt} byla zrušena kvůli blokovanému času: ${input.blockTitle}.\n\n` +
    (input.reason ? `Důvod: ${input.reason}\n\n` : '') +
    `Prosíme o novou rezervaci na jiný termín.\n\n` +
    `S pozdravem,\nTým salonu`
  );
}
